// src/app/services/favicon.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  setTitle(title: string): void {
    const titleEl = document.querySelector('#appTitle');
    if (titleEl) {
      titleEl.textContent = title;
    }
  }

  setFavicon(faviconUrl: string): void {
    const link: HTMLLinkElement = document.querySelector('#appFavicon') || this.createLinkElement();
    link.href = faviconUrl;
  }

  private createLinkElement(): HTMLLinkElement {
    const link = document.createElement('link');
    link.id = 'appFavicon';
    link.rel = 'icon';
    link.type = 'image/x-icon';
    document.head.appendChild(link);
    return link;
  }
}
